import { Controller } from "@hotwired/stimulus"
import { KTModal } from "@keenthemes/ktui"

export default class extends Controller {
  static targets = [
    "input",
    "dropzone",
    "processing",
    "filename",
    "notice",
    "modal",
    "input",
  ]
  static values = { riveScript: String }

  connect() {
    if (this.hasProcessingTarget)
      this.#loadRiveScript().then(() => this.setupRive())

    if (this.hasModalTarget) {
      this.modalTarget.addEventListener("hide", () => this.disconnect())
      document.addEventListener("turbo:before-stream-render", (e) => {
        const stream = e.detail.newStream
        if (!stream) return
        if (stream.getAttribute("target") === "calendar")
          KTModal.getInstance(this.modalTarget)?.hide()
      })
    }
  }

  disconnect() {
    if (this.hasProcessingTarget) this.cleanupRive()

    if (this.hasModalTarget) {
      this.filenameTarget.textContent = "未选择任何文件"
      this.filenameTarget.classList.add("text-gray-400")
      this.filenameTarget.classList.remove("text-slate-600")
      this.noticeTarget.textContent = ""
      this.inputTarget.value = ""
    }
  }

  triggerPicker() {
    this.inputTarget.click()
  }

  dragOver(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("scale-95", "border-[#055FFF]")
  }

  dragLeave(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("scale-95", "border-[#055FFF]")
  }

  drop(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("scale-95", "border-[#055FFF]")

    const file = event.dataTransfer.files[0]
    if (file) {
      this.handleFile(file)
    }
  }

  syncFilename(event) {
    const file = event.target.files[0]
    if (this.hasFilenameTarget) {
      this.filenameTarget.textContent = file ? file.name : "未选择任何文件"
      this.filenameTarget.classList.toggle("text-gray-400", !file)
      this.filenameTarget.classList.toggle("text-slate-600", !!file)
      this.noticeTarget.textContent = ""
    }
  }

  fileChanged(event) {
    const file = event.target.files[0]
    if (file) {
      this.handleFile(file)
    }
  }

  async handleFile(file) {
    if (!file.name.endsWith(".xlsx")) {
      alert("仅支持 .xlsx 格式文件")
      return
    }

    this.showProcessing()

    await new Promise((resolve) => setTimeout(resolve, 1000))

    if (this.inputTarget.files[0] !== file) {
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)
      this.inputTarget.files = dataTransfer.files
    }

    this.inputTarget.form.requestSubmit()
  }

  showProcessing() {
    this.processingTarget.classList.remove("hidden")
    this.processingTarget.classList.add("flex")
    this.rive?.play()
  }

  #loadRiveScript() {
    if (window.rive) return Promise.resolve()
    return new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = this.riveScriptValue
      script.onload = () => resolve()
      script.onerror = () => reject(new Error("Rive 加载失败"))
      document.body.appendChild(script)
    })
  }

  setupRive() {
    const canvas = this.processingTarget.querySelector("canvas")
    if (!canvas?.dataset.riveSrc) return

    this.rive = new rive.Rive({
      src: canvas.dataset.riveSrc,
      canvas: canvas,
      autoplay: false,
    })
  }

  cleanupRive() {
    this.rive?.stop()
    this.rive?.cleanup()
  }
}
